const self_test_messages = {
  self_test_title: ['self_test>>self_test_title', 'Self Test'],
  self_test_actions: {
    next: ['self_test>>self_test_action>>next', 'next'],
    previous: ['self_test>>self_test_action>>previous', 'previous'],
    finish_test: ['self_test>>self_test_action>>finish_test', 'finish test'],
  },
  recommendations: ['self_test>>self_test_recommendations', 'Recommendations'],
  results: ['self_test>>self_test_results', 'Results'],
  score_message: ['self_test>>self_test_sore_message', 'Score {{currentScore}} out of {{maxScore}}'],
  get_started: ['self_test>>self_test_get_started', 'Get started'],
  progress_metadata: ['self_test>>progress_metadata', 'Self-test information'],
  progress_title: ['self_test>>progress_title', 'Name of this self-test run'],
  progress_asset: ['self_test>>progress_asset', 'Related asset'],
  progress_assets_loading: ['self_test>>progress_assets_loading', 'Loading assets...'],
  progress_assets_empty: ['self_test>>progress_assets_empty', 'No selectable assets'],
  progress_assets_error: ['self_test>>progress_assets_error', 'Assets could not be loaded. Please try again.'],
  edit_progress_metadata: ['self_test>>edit_progress_metadata', 'Save self-test information'],
  template_name: ['self_test>>template_name', 'Self-test template'],
  completed_at: ['self_test>>completed_at', 'Completed'],
  selected_answer: ['self_test>>selected_answer', 'Selected answer'],
  no_answer: ['self_test>>no_answer', 'No answer'],
};

export default self_test_messages;
